var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseBg = function SvgCloseBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2775 14.2775C14.6474 13.9075 15.2473 13.9075 15.6173 14.2775L20 18.6602L24.3827 14.2775C24.7527 13.9075 25.3526 13.9075 25.7225 14.2775C26.0925 14.6474 26.0925 15.2473 25.7225 15.6173L21.3398 20L25.7225 24.3827C26.0925 24.7527 26.0925 25.3526 25.7225 25.7225C25.3526 26.0925 24.7527 26.0925 24.3827 25.7225L20 21.3398L15.6173 25.7225C15.2473 26.0925 14.6474 26.0925 14.2775 25.7225C13.9075 25.3526 13.9075 24.7527 14.2775 24.3827L18.6602 20L14.2775 15.6173C13.9075 15.2473 13.9075 14.6474 14.2775 14.2775Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-bg.aa71dd04.svg";
export { ForwardRef as ReactComponent };